export default __webpack_public_path__ + "static/media/match1.c5701a18.png";